import React, { useState } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { notificationSEND } from "../api/territory";

const Notif = () => {
  const [formData, setFormData] = useState({
    notification_title: "",
    notification_description: "",
    notification_link: "",
    persona: "",
  });
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);

  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // const payload = {
    //   notification_title: formData.notification_title,
    //   notification_description : formData.notification_description ,
    //   notification_link: formData.notification_link,
    //   persona: formData.persona,
    // };

    const payload = new FormData();
    payload.append("notification_title", formData.notification_title);
    payload.append(
      "notification_description",
      formData.notification_description
    );

    
    payload.append("persona", formData.persona);
    if (formData.notification_link.trim() !== "") {
      payload.append("notification_link", formData.notification_link);
    }

    try {
      setLoading(true);
      const requiredFields = ["notification_title", "notification_description", "persona"];
      const emptyFields = requiredFields.filter((field) => !formData[field as keyof typeof formData]);

      setInvalidFields(emptyFields);

      if (emptyFields.length > 0) {
        toast.error("Please fill all required fields.", {
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
        return;
      }
      const response = await notificationSEND(payload);
      if (!response) {
        toast.error("No data received or malformed response", {
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success(response?.message);
      setTimeout(() => {
       window.location.reload();
      }, 2000);
    } catch (error: any) {
      setFormData({
        notification_title: "",
        notification_description: "",
        notification_link: "",
        persona: "",
      });
      
      console.error("Failed to fetch  data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later",
          {
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }
        );
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching",
          {
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }
        );
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",
            {
              autoClose: false,
              closeOnClick: true,
              draggable: true,
            }
          );
        }
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <h3 className="text-xl font-bold text-gray-700">Notification</h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">
            Notification Title *
          </label>
          <input
            type="text"
            name="notification_title"
            value={formData.notification_title}
            onChange={handleChange}
            className={getInputClass("notification_title")}
            placeholder="Notification Title"
          />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">
            Notification Description *
          </label>
          <input
            type="text"
            name="notification_description"
            value={formData.notification_description}
            onChange={handleChange}
            className={getInputClass("notification_description")}
            placeholder="Notification Description"
          />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">
            Notification Link (Optional)
          </label>
          <input
            type="text"
            name="notification_link"
            value={formData.notification_link}
            onChange={handleChange}
            className="w-full border px-3 py-2"
            placeholder="Notification Link"
          />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">Select Persona</label>
          <select
            name="persona"
            value={formData.persona}
            onChange={handleChange}
            className={getInputClass("persona")}
          >
            <option value="">Select Persona</option>
            <option value="All">All</option>
            <option value="Preseller">Preseller</option>
            <option value="Salesman">Salesman</option>
            <option value="Delivery Driver">Delivery Driver</option>
            <option value="Hybrid (Saleman and Driver)">
              Hybrid (Saleman and Driver)
            </option>
          </select>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Submit {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default Notif;
